import React from "react";
import { StandardsDetailsSidebar } from "./StandardsDetailsSidebar"
export const StandardsDetailsWrapper = ({
  children,
  hideContact = false,
  hideTitle = false,
}) => {
  return (
    <section className="services-details-area pt-120 pb-120">
      <div className="container">
        <div className=" justify-content-center">
          {/* content */}
          <div className="col-71 order-0 order-lg-2">{children}</div>

          {/* sidebar 
          <div className="col-29">
            <StandardsDetailsSidebar
              hideTitle={hideTitle}
              hideContact={hideContact}
            />
          </div>*/}
        </div>
      </div>
    </section>
  );
};
